/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitationContextResponseEnterpriseOrganization
 */
export interface InvitationContextResponseEnterpriseOrganization {
    /**
     * Whether the organization has a single company
     * @type {boolean}
     * @memberof InvitationContextResponseEnterpriseOrganization
     */
    singleCompany?: boolean;
    /**
     * the number of members in the organization
     * @type {number}
     * @memberof InvitationContextResponseEnterpriseOrganization
     */
    nbTotalMembers?: number;
    /**
     * the number of companies in the organization
     * @type {number}
     * @memberof InvitationContextResponseEnterpriseOrganization
     */
    nbCompanies?: number;
    /**
     * the name of the organization
     * @type {string}
     * @memberof InvitationContextResponseEnterpriseOrganization
     */
    name?: string;
    /**
     * The contract reference number of the organization
     * @type {string}
     * @memberof InvitationContextResponseEnterpriseOrganization
     */
    contractReference?: string;
}

/**
 * Check if a given object implements the InvitationContextResponseEnterpriseOrganization interface.
 */
export function instanceOfInvitationContextResponseEnterpriseOrganization(value: object): value is InvitationContextResponseEnterpriseOrganization {
    return true;
}

export function InvitationContextResponseEnterpriseOrganizationFromJSON(json: any): InvitationContextResponseEnterpriseOrganization {
    return InvitationContextResponseEnterpriseOrganizationFromJSONTyped(json, false);
}

export function InvitationContextResponseEnterpriseOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationContextResponseEnterpriseOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'singleCompany': json['singleCompany'] == null ? undefined : json['singleCompany'],
        'nbTotalMembers': json['nbTotalMembers'] == null ? undefined : json['nbTotalMembers'],
        'nbCompanies': json['nbCompanies'] == null ? undefined : json['nbCompanies'],
        'name': json['name'] == null ? undefined : json['name'],
        'contractReference': json['contractReference'] == null ? undefined : json['contractReference'],
    };
}

export function InvitationContextResponseEnterpriseOrganizationToJSON(value?: InvitationContextResponseEnterpriseOrganization | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'singleCompany': value['singleCompany'],
        'nbTotalMembers': value['nbTotalMembers'],
        'nbCompanies': value['nbCompanies'],
        'name': value['name'],
        'contractReference': value['contractReference'],
    };
}

